<h2 mat-dialog-title>{{ "add_functional_help" | transloco }}</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
    <div class="main-table">
        <div class="main-table-toolbar">
            <div class="main-toolbar-container">
                <div class="main-toolbar-spacer"></div>
                <div class="main-toolbar-filter-container">
                    <div class="main-toolbar-filter">
                        <div class="filter-item">
                            <pixl-free-filter-input
                                [matIcon]="'search'"
                                [hint]="getSearchFilterHint()"
                                [minLength]="freeFilterLen"
                                (onKeyUpChange)="setNameFilter($event)"
                            />
                        </div>
                        <div class="filter-item">
                            <pixl-competency-cb (onStateChange)="setCompetencyFilter($event)" />
                        </div>

                        <div class="filter-item">
                            <pixl-type-cb
                                (onStateChange)="setKindFilter($event)"
                                [matLabelText]="'type' | transloco"
                            />
                        </div>

                        <div class="filter-item">
                            <pixl-state-cb
                                (onStateChange)="setStateFilter($event)"
                                [withEmptyOption]="true"
                            />
                        </div>
                    </div>
                    <div class="main-toolbar-spacer-right"></div>
                </div>
                <div class="table-header-overlay"></div>
            </div>
        </div>

        <div class="table-container mat-elevation-z4">
            <table
                mat-table
                [dataSource]="dataSource"
                matSort
                (matSortChange)="announceSortChange($event)"
            >
                <ng-container matColumnDef="name">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                    >Name</th>
                    <td
                        mat-cell
                        *matCellDef="let functionalHelp"
                    >{{ functionalHelp.name }}</td>
                </ng-container>

                <ng-container matColumnDef="exerciseKind">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                    >Typ</th>
                    <td
                        mat-cell
                        *matCellDef="let functionalHelp"
                    >
                        <pixl-lang
                            [key]="functionalHelp.exerciseKind"
                            [keySuffix]="functionalHelp.exerciseSubKind?.toString()"
                        ></pixl-lang>
                    </td>
                </ng-container>

                <ng-container matColumnDef="competency">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                    >Fach</th>
                    <td
                        mat-cell
                        *matCellDef="let functionalHelp"
                    >{{ functionalHelp?.getCompetency()?.name || "---" }}</td>
                </ng-container>

                <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumns; sticky: true"
                ></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    (click)="setSelectedRow(row)"
                    [class.selected-row]="data.id === row.id"
                    [matTooltip]="'click_row_to_select' | transloco"
                ></tr>
            </table>
            <pixl-main-pagination [pageChangeCallback]="paginationChanged"></pixl-main-pagination>
        </div>
    </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button
        mat-raised-button
        (click)="onCancel()"
    >{{ "abort" | transloco }}</button>
    <button
        mat-raised-button
        (click)="onSave()"
    >{{ "apply" | transloco }}</button>
</mat-dialog-actions>